import useViewModel from "./viewModel";
import View from "./views";
import React from "react";

const OtherDevice = () => {
  const viewModel = useViewModel();

  return <View {...viewModel} />;
};

export default OtherDevice;
